import React, { useState } from "react";
import styles from "./Login.module.css";
import Logo from "../../components/Logo";
import IcEye from "../../components/Svg/IcEye";
import { Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Button from "../../components/Button";

export default function Login() {
  const { signIn } = useAuth();
  const [loading, setloading] = useState();
  const [loginData, setloginData] = useState();

  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async () => {
    try {
      setloading(true);
      await signIn({
        email: loginData?.email,
        password: loginData?.password,
        type: "formando",
      });
      // navigate(from, { replace: true });
    } catch (__error) {
      console.log(__error);
    } finally {
      setloading(false);
    }
  };

  return (
    <div className={`${styles.wrapLogin} ${styles._formando}`}>
      <div className="text-center">
        <Logo />
        <p className="mt-3">
          Fazer Login no Painel do <b style={{ fontSize: "1.5em" }}>Formando</b>
        </p>
      </div>
      <Form onSubmit={handleLogin}>
        <Form.Group className={`${styles.inputBox} lince-input`}>
          <p className="m-0">Email</p>
          <div className="lince-input__text">
            <Form.Control
              type="email"
              autoCorrect="off"
              autoCapitalize="off"
              value={loginData?.email}
              onChange={__ev => {
                setloginData({
                  ...loginData,
                  email: __ev.target.value,
                });
              }}
            />
          </div>
        </Form.Group>
        <Form.Group className={`${styles.inputBox} lince-input mt-2`}>
          <p className="m-0">Senha</p>
          <div className="position-relative">
            <Form.Control
              type={showPassword ? `text` : `password`}
              autoCorrect="off"
              autoCapitalize="off"
              value={loginData?.password}
              onChange={__ev => {
                setloginData({
                  ...loginData,
                  password: __ev.target.value,
                });
              }}
            />
            <i className={`showPassword ${styles.showPassword}`} onClick={e => setShowPassword(!showPassword)}>
              <IcEye />
            </i>
          </div>
        </Form.Group>
        <div className={`${styles.controlesLogin} controlesLogin`}>
          <NavLink to="/password-recovery?t=f" className="esqueciSenha">
            Redefinir Senha
          </NavLink>
        </div>
        <Button
          color="primary"
          loading={loading}
          onClick={() => {
            handleLogin();
          }}
          className="w-100 mt-4 p-4"
        >
          Entrar
        </Button>
      </Form>
    </div>
  );
}
